import _styled from "@emotion/styled-base";
import React, { memo } from 'react';
import { useTheme } from 'emotion-theming';

var Svg = _styled("svg", {
  target: "eokdqmt0",
  label: "Svg"
})("&:hover{circle{fill:", function (_ref) {
  var hoverBackgroundColor = _ref.hoverBackgroundColor;
  return hoverBackgroundColor ? hoverBackgroundColor : 'transparent';
}, ";}path{fill:", function (_ref2) {
  var hoverColor = _ref2.hoverColor;
  return hoverColor;
}, ";stroke:", function (_ref3) {
  var hoverColor = _ref3.hoverColor;
  return hoverColor;
}, ";}}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));

export var LinkedIn = /*#__PURE__*/memo(function (_ref4) {
  var _ref4$height = _ref4.height,
      height = _ref4$height === void 0 ? 30 : _ref4$height,
      _ref4$variant = _ref4.variant,
      variant = _ref4$variant === void 0 ? 'primary' : _ref4$variant,
      _ref4$width = _ref4.width,
      width = _ref4$width === void 0 ? 30 : _ref4$width;

  var _useTheme = useTheme(),
      colors = _useTheme.colors,
      _useTheme$socialProfi = _useTheme.socialProfileSvgs,
      inverse = _useTheme$socialProfi.inverse,
      neutral = _useTheme$socialProfi.neutral,
      primary = _useTheme$socialProfi.primary;

  var backgroundColor = 'transparent';
  var fillColor = colors.secondary;
  var hoverBackgroundColor = 'transparent';
  var hoverColor = colors.tertiary;

  switch (variant) {
    case 'neutral':
      backgroundColor = neutral.backgroundColor;
      fillColor = neutral.fillColor;
      hoverBackgroundColor = neutral.hoverBackgroundColor;
      hoverColor = neutral.hoverFillColor;
      break;

    case 'inverse':
      fillColor = inverse.fillColor;
      hoverColor = inverse.hoverFillColor;
      break;

    case 'primary':
    default:
      fillColor = primary.fillColor;
      hoverColor = primary.hoverFillColor;
      break;
  }

  return /*#__PURE__*/React.createElement(Svg, {
    height: height,
    width: width,
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26.1 26.1",
    style: {
      enableBackground: 'new 0 0 26.1 26.1'
    },
    xmlSpace: "preserve",
    hoverColor: hoverColor,
    hoverBackgroundColor: hoverBackgroundColor
  }, /*#__PURE__*/React.createElement("circle", {
    id: "top",
    cx: 13.1,
    cy: 13.1,
    r: 13.1,
    fill: backgroundColor
  }), /*#__PURE__*/React.createElement("path", {
    fill: fillColor,
    stroke: fillColor,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M13,26.1c-7.2,0-13-5.8-13-13s5.8-13,13-13s13,5.8,13,13C26,20.2,20.2,26,13,26.1z M13,1C6.4,1,1,6.4,1,13 s5.4,12,12,12s12-5.4,12-12S19.6,1,13,1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: fillColor,
    stroke: fillColor,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M9.3,17.9c-0.3,0-0.5-0.2-0.5-0.5v-7.1C8.8,10,9,9.8,9.3,9.8l0,0c0.3,0,0.5,0.2,0.5,0.5l0,0v7.1 C9.8,17.6,9.6,17.9,9.3,17.9L9.3,17.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: fillColor,
    stroke: fillColor,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M12.7,17.9c-0.3,0-0.5-0.2-0.5-0.5l0,0v-7.1c0-0.3,0.2-0.5,0.5-0.5l0,0c0.3,0,0.5,0.2,0.5,0.5l0,0v7.1 C13.2,17.6,13,17.9,12.7,17.9L12.7,17.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: fillColor,
    stroke: fillColor,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M17.3,17.9c-0.3,0-0.5-0.2-0.5-0.5l0,0v-4.7c0-1-0.8-1.8-1.8-1.8s-1.8,0.8-1.8,1.8c0,0.3-0.2,0.5-0.5,0.5l0,0 c-0.3,0-0.5-0.2-0.5-0.5l0,0c0-1.6,1.3-2.8,2.8-2.8s2.8,1.3,2.8,2.8v4.7C17.8,17.6,17.6,17.9,17.3,17.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: fillColor,
    stroke: fillColor,
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    d: "M9.3,8.5c-0.5,0-0.9-0.4-0.9-0.9s0.4-0.9,0.9-0.9s0.9,0.4,0.9,0.9l0,0C10.2,8.1,9.8,8.5,9.3,8.5z M9.3,7.5 C9.3,7.5,9.2,7.6,9.3,7.5C9.2,7.7,9.4,7.7,9.3,7.5C9.4,7.6,9.3,7.5,9.3,7.5z"
  }));
});